import FlashLib from "flashlib_onlyplay";
import Main from "./Main";

import ReelsContainer from "./reels/ReelsContainer";
import OverlayContainer from "Engine/containers/overlay/BaseOverlayContainer";

import Symbol from "./symbols/Symbol";

import StartScreenContainer from './startScreen/startScreen';
import InfoPopupContainer from "Engine/containers/InfoPopupContainer";

import PaytableContainer from "./paytable/PaytableContainer";
import PaytableContent from "./paytable/PaytableContent";
import PaytableControls from "./paytable/PaytableControls";
import SymbolAnimation from './symbols/SymbolAnimation';
import ControllerJackpotPanels from './jackpot/JackpotPanels/ControllerJackpotPanels';
import PopupWin from './popups/popupWin/PopupWin';
import BackgroundContainer from './background/BackgroundContainer';
import ControllerReels from 'Engine/base/reels/ControllerReels';
import ControllerBonusGameStart from './popups/freespins/ControllerFreespinsStart';
import ControllerBonusGameEnd from './popups/freespins/ControllerFreespinsEnd';
import ControllerSlot from './slot/ControllerSlot';
import ControllerJackpotPanel from './jackpot/JackpotPanels/ControllerJackpotPanel';
import ControllerAntisipator from './reels/ControllerAntisipator';
import BaseGameButton from './ui/BaseGameButton';

FlashLib.registerClass('Button', BaseGameButton);

FlashLib.registerClass('Main', Main);
FlashLib.registerClass('ReelsContainer', ReelsContainer);
FlashLib.registerClass('Symbol', Symbol);

FlashLib.registerClass('StartScreenContainer', StartScreenContainer);

FlashLib.registerClass('InfoPopupContainer', InfoPopupContainer);

FlashLib.registerClass('OverlayContainer', OverlayContainer);

FlashLib.registerClass('PaytableContainer', PaytableContainer);
FlashLib.registerClass('PaytableContent', PaytableContent);
FlashLib.registerClass('PaytableControls', PaytableControls);
FlashLib.registerClass('SymbolAnimation', SymbolAnimation);
FlashLib.registerClass('ControllerJackpotPanels', ControllerJackpotPanels);
FlashLib.registerClass('PopupWin', PopupWin);
FlashLib.registerClass('BackgroundContainer', BackgroundContainer);
FlashLib.registerClass('ControllerReels', ControllerReels);
FlashLib.registerClass('ControllerBonusGameStart', ControllerBonusGameStart);
FlashLib.registerClass('ControllerBonusGameEnd', ControllerBonusGameEnd);
FlashLib.registerClass('ControllerSlot', ControllerSlot);
FlashLib.registerClass('ControllerJackpotPanel', ControllerJackpotPanel);
FlashLib.registerClass('ControllerAntisipator', ControllerAntisipator);
